import React from 'react';
type Variant = 'primary' | 'secondary' | 'ghost' | 'gold';
type Size = 'sm' | 'md' | 'lg';
interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  asChild?: boolean;
  href?: string;
}
const base = 'inline-flex items-center justify-center gap-2 font-medium tracking-tight transition-all duration-200 rounded-md border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/60 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
const variants: Record<Variant, string> = {
  primary: 'bg-white text-navy-deep border-white hover:bg-slate-100',
  secondary: 'bg-transparent text-white border-white/30 hover:border-white/60 hover:bg-white/5',
  ghost: 'bg-transparent text-navy-deep border-transparent hover:bg-navy-deep/5',
  gold: 'bg-gold text-navy-deep border-gold hover:bg-gold-soft'
};
const sizes: Record<Size, string> = {
  sm: 'h-9 px-4 text-sm',
  md: 'h-11 px-5 text-sm',
  lg: 'h-12 px-6 text-[15px]'
};
export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  href,
  children,
  ...rest
}: Props) {
  const cls = `${base} ${variants[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} className={cls} data-id="element-652">
        {children}
      </a>;
  }
  return <button className={cls} {...rest} data-id="element-653">
      {children}
    </button>;
}